$(document).ready(function () {
    $('#table-suppliers').dataTable({
        "processing": true,
        "serverSide": true,
        "ajax": "/get-suppliers",
        "columns": [
            {data: 'id'},
            {data: 'name'},
            {data: 'phone'},
        ],
        order: [[1,'desc']],
        "columnDefs": [
            {
                "targets": 3,
                "render": function (data, type, row, meta) {
                    let status = row.status;
                    let uuid = row.uuid;
                    return '<button data-toggle="tooltip" data-placement="top" title="Editar proveedor" ' +
                        'class="btn btn-primary edit-supplier btn-sm"' + 'data-id ="' + row.id + '">' +
                        '<i class="far fa-edit"></i>' +
                        '</button>' +
                        btn_update_status(status, uuid)
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    });

    $("#new-supplier").on("click", function (e) {
        e.preventDefault();
        $(".modal-suppliers-tittle").text('Agregar proveedor')
        $(".text_button_supplier").text('Agregar')
        $('#form-suppliers')[0].reset();
        $('.item-uuid').val('')
        $('.item-action').val('create')
        $("#modal-suppliers").modal('show');
    })

    $("#table-suppliers tbody").on('click', '.edit-supplier', function () {

        $(".text_button_supplier").text('Actualizar')
        let list_suppliers = $("#table-suppliers").DataTable();
        let rowData = list_suppliers.row($(this).parents('tr')).data();
        $.each(rowData, function (index, value) {
            if (index === "freights") {
                $('.item-freights').val(value).trigger("chosen:updated");
            }
            $(".item-" + index).val(value)
        })
        $('.item-action').val('update')
        $(".modal-suppliers-tittle").text('Editar proveedor')
        $("#modal-suppliers").modal('show');
    })

    $("#table-suppliers tbody").on('click', '.update-status-supplier', function (e) {
        e.preventDefault()
        let uuid = $(this).data('uuid');
        let data = new FormData()
        data.append('uuid', uuid)
        sendData('/update-supplier', data )
    })

    $("#form-suppliers").on("submit", function (e) {
        e.preventDefault();
        let data = new FormData(this)
        sendData('/valida-register', data)
    })


    function btn_update_status(row_status, row_uuid) {
        let status = get_global_status(row_status)
        return '<button data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' +
            'class="btn btn-' + status.color_clas + ' update-status-supplier btn-sm m-1"' + 'data-uuid ="' + row_uuid + '">' +
            '<i class="' + status.icon + '"></i>' +
            '</button>'
    }

    function sendData(route, data) {
        $.ajax({
            url: route,
            method: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {

            },
            success: function (response) {
                if (response.success) {
                    alertWithBtn(response.msg)
                    $('#table-suppliers').DataTable().ajax.reload();
                    $("#modal-suppliers").modal('hide');
                } else {
                    alertError(response.msg)
                }
            },
            error: function (errors, xhr, status) {

                $.LoadingOverlay("hide");
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $("#item-error-" + index).html(value)
                });
            },
            complete: function () {

            }
        });
    }

})
